<template lang="html">
  <div class="carousel slide carousel-fade">
    <div class="carousel-inner">
      <template v-for="(img, index) in images">
        <div
          :key="index"
          :class="`carousel-item slideshow-image ${index === 0 ? 'active' : ''}`"
          :style="{
            backgroundImage: `url(${imageWithExtensionSmall(img)})`,
            transitionDuration: `${duration}s`
          }">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { imageWithExtensionSmall } from '@/helpers'

export default {
  props: {
    /** assigned key number */
    index: Number,
    images: Array,
    /** time between images */
    inverval: Number
  },

  data: () => ({
    /** smartphones utilities */
    canTouch: true,
    /** fade duration */
    duration: 1.5
  }),

  mounted () {
    /** can't autoplay */
    $(this.$el).carousel({
      interval: this.interval || 5000,
      touch: this.canTouch
    }).carousel('cycle')
  },

  methods: {
    imageWithExtensionSmall
  }
}
</script>

<style lang="scss">
  .slideshow-image {
    height: 84%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/PublicationSlideshow.vue